import React from 'react';

function HiddenField(hiddenFieldProps) {
  return /*#__PURE__*/React.createElement("input", {
    name: hiddenFieldProps.name,
    value: hiddenFieldProps.defaultValue,
    type: "hidden"
  });
}

export { HiddenField as default };
